import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "InputAddon-root_1L4AP",
  "big": "InputAddon-big_3eJHo",
  "small": "InputAddon-small_2gJSq",
  "roundedTopLeft": "InputAddon-roundedTopLeft_2OCyM",
  "roundedTopRight": "InputAddon-roundedTopRight_1aiZt",
  "roundedBottomRight": "InputAddon-roundedBottomRight_ojSuM",
  "roundedBottomLeft": "InputAddon-roundedBottomLeft_1pl4q",
  "borderedTop": "InputAddon-borderedTop_e3ToP",
  "borderedRight": "InputAddon-borderedRight_20Myo",
  "borderedBottom": "InputAddon-borderedBottom_3ioQj",
  "borderedLeft": "InputAddon-borderedLeft_27M3W",
  "paddedLeft": "InputAddon-paddedLeft_1ESh8",
  "paddedRight": "InputAddon-paddedRight_1LB33",
  "padded": "InputAddon-padded_2qwY3 InputAddon-paddedLeft_1ESh8 InputAddon-paddedRight_1LB33",
  "withIcon": "InputAddon-withIcon_hRlIw",
  "theme-default": "InputAddon-theme-default_o7GP9",
  "theme-error": "InputAddon-theme-error_1z-bX",
  "theme-disabled": "InputAddon-theme-disabled_2rWq6",
  "isFocused": "InputAddon-isFocused_2ftLR",
  "hasError": "InputAddon-hasError_34eef InputAddon-theme-error_1z-bX",
  "isDisabled": "InputAddon-isDisabled_ADvrx InputAddon-theme-disabled_2rWq6"
};
function InputAddon({
  tagName = 'span',
  variant = 'big',
  theme,
  focused,
  hasError,
  disabled,
  borderedTop = true,
  borderedRight,
  borderedBottom = true,
  borderedLeft,
  roundedTopLeft,
  roundedTopRight,
  roundedBottomRight,
  roundedBottomLeft,
  padded,
  paddedLeft,
  paddedRight,
  withIcon,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles['theme-default']]: !hasError && !disabled,
    [styles.isFocused]: focused,
    [styles.hasError]: hasError,
    [styles.isDisabled]: disabled,
    [styles.borderedTop]: borderedTop,
    [styles.borderedRight]: borderedRight,
    [styles.borderedBottom]: borderedBottom,
    [styles.borderedLeft]: borderedLeft,
    [styles.roundedTopLeft]: roundedTopLeft,
    [styles.roundedTopRight]: roundedTopRight,
    [styles.roundedBottomRight]: roundedBottomRight,
    [styles.roundedBottomLeft]: roundedBottomLeft,
    [styles.padded]: padded,
    [styles.paddedLeft]: paddedLeft,
    [styles.paddedRight]: paddedRight,
    [styles.withIcon]: withIcon,
    [styles.big]: variant === 'big',
    [styles.small]: variant === 'small'
  }, className);
  return /*#__PURE__*/_jsx(Base, {
    tagName: tagName,
    className: rootClasses,
    ...extraProps
  });
}
export default InputAddon;